import Store from '@get-bridge/learn-legacy-shared/dist/core/Store'
import deleteNotification from '../data_requests/deleteNotification'
import getNotifications from '../data_requests/getNotifications'
import updateNotification from '../data_requests/updateNotification'
import NotificationSchema from '../schemas/NotificationSchema'
import { FetchStatus } from '../../constants'

export default Store({
  schema: NotificationSchema,

  initialize() {
    this.fetchStatus = FetchStatus.UNSENT
  },

  getAll() {
    return this.cache.getCollection({})
  },

  fetchAll() {
    this.fetchStatus = FetchStatus.LOADING
    return getNotifications().then((notifications) => {
      this.fetchStatus = FetchStatus.DONE
      this.cache.setCollection({}, notifications)
      return notifications
    }, e => {
      this.fetchStatus = FetchStatus.ERROR
      throw e
    })
  },

  update(notification) {
    return updateNotification(notification).then(() => {
      this.cache.add(notification)
    })
  },

  delete(notification) {
    return deleteNotification(notification.id).then(() => {
      this.cache.remove(notification.id)
    })
  },
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/notifications/stores/NotificationStore.js